<template>
  <div class="index">
    <Header></Header>  
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../hospital/header.vue";
import Footer from "../components/footer.vue";
export default {
  name: "index",
  components: {
    Header: Header,
    Footer:Footer
  },
  beforeCreate() {
      document.querySelector('body').setAttribute('style', 'background-color:#F5F5F5;')
    },
    //销毁前清除
    beforeDestroy() {
      document.querySelector('body').removeAttribute('style')
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* body{
  background: #F5F5F5;
} */
</style>



// WEBPACK FOOTER //
// src/hospital/index.vue